<div class="size-progress py-3 border-top border-grey-65">
    <div class="d-flex align-items-center">
        <div class="px-3 fs-1">{{ getTransformedValue()|number:'1.2-2':'fr' }}/{{ max }} Mo</div>
        <div class="pr-3 flex-fill">
            <progressbar [value]="getTransformedValue()" type="success" [max]="100"><b>{{ getPercentage() }}%</b></progressbar>
        </div>
    </div>
</div>